<script>
import { mapGetters } from 'vuex';
import { useTrack } from 'dashboard/composables';
import TableFooter from 'dashboard/components/widgets/TableFooter.vue';

import NotificationTable from './NotificationTable.vue';

import { ACCOUNT_EVENTS } from '../../../../helper/AnalyticsHelper/events';
export default {
  components: {
    NotificationTable,
    TableFooter,
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      meta: 'notifications/getMeta',
      records: 'notifications/getNotifications',
      uiFlags: 'notifications/getUIFlags',
    }),
  },
  mounted() {
    this.$store.dispatch('notifications/get', { page: 1 });
  },
  methods: {
    onPageChange(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
      this.$store.dispatch('notifications/get', { page });
    },
    openConversation(notification) {
      const {
        primary_actor_id: primaryActorId,
        primary_actor_type: primaryActorType,
        notification_type: notificationType,
      } = notification;

      useTrack(ACCOUNT_EVENTS.OPEN_CONVERSATION_VIA_NOTIFICATION, {
        notificationType,
      });
      this.$store.dispatch('notifications/read', {
        id: notification.id,
        primaryActorId,
        primaryActorType,
        unreadCount: this.meta.unreadCount,
      });

      const base = `/app/accounts/${this.accountId}`;
      const actorId =
        notification.primary_actor?.id || primaryActorId;

      if (primaryActorType === 'Conversation') {
        const convId =
          notification.primary_actor?.display_id || primaryActorId;
        this.$router.push(`${base}/conversations/${convId}`);
        return;
      }

      if (
        primaryActorType === 'Inbox' ||
        notificationType === 'channel_disconnected' ||
        notificationType === 'qr_code_needed'
      ) {
        if (actorId) {
          this.$router.push(`${base}/settings/inboxes/${actorId}`);
          return;
        }
      }

      if (
        notification.primary_actor?.type === 'captain_insight' ||
        notificationType === 'captain_daily_briefing' ||
        notificationType === 'captain_insight_alert'
      ) {
        this.$router.push(`${base}/captain/brain/insights`);
        return;
      }

      if (
        notificationType === 'task_assigned' ||
        notificationType === 'task_due_soon'
      ) {
        this.$router.push(`${base}/crm/tasks`);
        return;
      }

      if (
        notificationType === 'deal_won' ||
        notificationType === 'deal_lost'
      ) {
        if (actorId) {
          this.$router.push(`${base}/crm/board/${actorId}`);
          return;
        }
      }

      if (actorId && primaryActorType === 'Conversation') {
        this.$router.push(`${base}/conversations/${actorId}`);
      }
    },
    onMarkAllDoneClick() {
      useTrack(ACCOUNT_EVENTS.MARK_AS_READ_NOTIFICATIONS);
      this.$store.dispatch('notifications/readAll');
    },
  },
};
</script>

<template>
  <div class="h-full overflow-y-auto">
    <div class="flex flex-col h-full">
      <NotificationTable
        :notifications="records"
        :is-loading="uiFlags.isFetching"
        :is-updating="uiFlags.isUpdating"
        :on-click-notification="openConversation"
        :on-mark-all-done-click="onMarkAllDoneClick"
      />
      <TableFooter
        class="border-t border-n-weak"
        :current-page="Number(meta.currentPage)"
        :total-count="meta.count"
        :page-size="15"
        @page-change="onPageChange"
      />
    </div>
  </div>
</template>
